export default __webpack_public_path__ + "static/media/flash-flood.5b8d6853.svg";